import titles from './titles.json';
import competitions from './competition.json';
import hederstegn from './hederstegn.json';
import championships from './championships.json';

export const Score = {
    "1": 10,
    "2": 7,
    "3": 5,
    "4": 3,
    "5": 1
}

export const awardToText = {
    "-1": "Ekstra",
    1: "Gull",
    2: "Sølv",
    3: "Bronse",
    4: "Hederlig omtale",
    5: "Antatt"
}

export const awardToNumber = {
    "Ekstra": -1,
    "Gull": 1,
    "Sølv": 2,
    "Bronse": 3,
    "Hederlig omtale": 4,
    "Antatt": 5
}

export const sortByAward = (titles) => {
    return titles.sort((a, b) => awardToNumber[a.award] - awardToNumber[b.award]);
}

export const getOnlyAwards = (titles) => {
    return titles.filter(t => awardToNumber[t.award] <= 4)
}

export const getTitles = () => titles;
export const getCompetitions = () => competitions;
export const getCompetitionId = (row) => row.imageId.split("-").slice(0, -1).join("-");
export const getHederstegn = () => hederstegn;
export const getChampionships = () => championships;